module.exports = __webpack_public_path__ + "img/74.112d0522.jpg";